module.exports = __webpack_public_path__ + "static/media/checkIcon.bf5a8003.svg";